declare global {
  interface StringConstructor {
    /**
     * ( Custom function ) 
     * Returns true if the string is Null, Undefined Or Empty (Empty meaning that after clearing all non-word characters, spaces and newLines the string is equal to "")
     * @param s String to check
     */
    isNullOrUndefinedOrWhitespace(s: string | null | undefined): s is null | undefined;
  }
}


String.isNullOrUndefinedOrWhitespace = (s: string | null | undefined): s is null | undefined => {
    if (s == null) {
      return true;
    }

    if (!isNaN(+s)) {
      s = s.toString();
    }
  
    let cleanRegEx = new RegExp('(\W|\n|\r|\t|\s)', 'g')
    let cleanString = s.replaceAll(cleanRegEx, '');
    return cleanString == ''
  }

export {}